import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Button,
  Grid2,
  Card,
  CardContent,
  CardMedia,
  Box,
} from "@mui/material";
import { styled } from "@mui/system";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Footer from "./Footer";
import Navbar from "./Navbar"; // Import the Navbar component
// import OurServices from "./OurServices";
import OurServicesNew from "./OurServicesNew";
import Hero from "./Hero";
import AppPreview from "./AppPreview";
// import RiskStep from "./RiskStep";
import AppFeatures from "./AppFeatures";
// import Products from "./Products";
import WhyUs from "./whyUs";
// import ExploreMF from "./ExploreMF";
// import MFBenefits from "./MFBenefits";
import HorizontalScroll from "./HorizontalScroll";
import Features from "./Features";
// import SplashScreen from "./SplashScreen";


// ... existing imports ...



function HomePage() {
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate("/banking-products");
  };

  const commingSoon = () => {
    navigate("/coming-soon");
  };


  return (
    <>
      <Navbar />
      <Hero />
      <AppFeatures />
      <WhyUs />
      {/* <OurServicesNew /> */}
      <Features />
      <AppPreview />
      <Footer />
    </>
  );
}

export default HomePage;
